import React from 'react';
import { Link } from 'react-router-dom';
import { FiPlayCircle, FiStar, FiCalendar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

export default function Home() {
  return (
    <div className="space-y-16 py-8">
      {/* Hero Section */}
      <section className="relative rounded-2xl overflow-hidden shadow-2xl border-2 border-sun-yellow/30 mx-4 sm:mx-8 lg:mx-auto max-w-7xl">
        <div className="absolute inset-0 bg-gradient-to-r from-grunge-black via-grunge-black/80 to-transparent z-10"></div>
        <img 
          src="/hero-bg.jpeg"
          alt="Live Performance" 
          className="w-full h-[60vh] object-cover"
        />
        <div className="absolute inset-0 z-20 flex flex-col justify-center p-8 md:p-16">
          <motion.h1 
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-6xl md:text-8xl font-display text-white mb-4 drop-shadow-[0_5px_5px_rgba(0,0,0,0.8)]"
          >
            WELCOME TO <br/><span className="text-sun-yellow">THE CLUB</span>
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-xl md:text-2xl text-gray-200 mb-8 max-w-2xl font-light"
          >
            Your exclusive access to pre-sale tickets, VIP experiences, unheard tracks, and the inner circle community.
          </motion.p>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-wrap gap-4"
          >
            <Link to="/community" className="bg-sun-yellow text-grunge-black font-bold uppercase py-4 px-8 rounded-full hover:bg-white transition-all transform hover:scale-105 flex items-center gap-2">
              <SafeIcon icon={FiStar} /> Join Now
            </Link>
            <Link to="/media" className="bg-transparent border-2 border-white text-white font-bold uppercase py-4 px-8 rounded-full hover:bg-white hover:text-grunge-black transition-all flex items-center gap-2">
              <SafeIcon icon={FiPlayCircle} /> Latest Video
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Featured Content Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* News Card */}
          <div className="glass-panel p-6 flex flex-col justify-between group hover:border-sun-yellow transition-colors">
            <div>
              <h3 className="text-2xl font-display text-sun-yellow mb-4">Latest News</h3>
              <p className="text-gray-300 mb-4 line-clamp-3">
                The new album is officially in the works! Studio sessions have been intense and we can't wait to share snippets with club members first.
              </p>
            </div>
            <Link to="/community" className="text-sun-yellow font-bold uppercase text-sm mt-4 inline-flex items-center group-hover:text-white transition-colors">
              Read More &rarr;
            </Link>
          </div>

          {/* Tour Card */}
          <div className="glass-panel p-6 flex flex-col justify-between group hover:border-sun-yellow transition-colors bg-gradient-to-br from-grunge-gray to-grunge-black">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <SafeIcon icon={FiCalendar} className="text-sun-yellow w-6 h-6" />
                <h3 className="text-2xl font-display text-white">Next Show</h3>
              </div>
              <p className="text-xl font-bold">Madison Square Garden</p>
              <p className="text-sun-yellow">Oct 24, 2024 • New York, NY</p>
            </div>
            <Link to="/events" className="mt-6 bg-white/10 hover:bg-sun-yellow hover:text-black border border-white/20 text-white font-bold py-2 px-4 rounded text-center transition-all">
              Get Tickets
            </Link>
          </div>

          {/* Merch Highlight */}
          <div className="glass-panel p-0 overflow-hidden group relative">
            <img 
              src="https://meredithbrooks.com/wp-content/uploads/2026/04/Meredith-Brooks_Blurring-The-Edges_3D_88845f91-6876-437e-a1c9-c30ffd4d1b80.webp" 
              alt="Exclusive Merch" 
              className="w-full h-full object-cover opacity-70 group-hover:opacity-100 transition-opacity duration-500 min-h-[250px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent flex flex-col justify-end p-6">
              <h3 className="text-2xl font-display text-white mb-2">Club Exclusive Merch</h3>
              <Link to="/store" className="text-sun-yellow font-bold uppercase text-sm inline-flex items-center hover:text-white transition-colors">
                Shop Now &rarr;
              </Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
